import { LINKEDIN_AUTOMATION_STAGE_STATUSES } from './linkedinAutomationStageStatuses'
import { homeFeedUrl } from './linkedinUrls'
import { updatePlatformUserAccountData } from '../../data/platform/platformUserAccountData'
import { PLATFORM, StageType } from '../../utils/enums'
import { StageDef } from '../automationMachineInterfaces'

enum StageKey {
  LINKEDIN_GET_USERNAME = 'LINKEDIN_GET_USERNAME',
}

export const gatherAccountUsernameStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.LINKEDIN_GET_USERNAME,
    status: LINKEDIN_AUTOMATION_STAGE_STATUSES.INITIALIZING_PLAYBOOK,
    url: homeFeedUrl,
    action: async (machineContext, userContext) => {
      const { platform, userId } = userContext

      const matchingElements = [...document.getElementsByTagName('a')].filter(
        (x) => x.href.includes('/in/'),
      )

      let username
      if (matchingElements.length > 0) {
        const urlParts = matchingElements[0].href.split('/in/').reverse()
        if (urlParts.length > 1) {
          username = urlParts[0].replace('/', '')
        }
      }

      if (userId && userId !== 'null' && username) {
        await updatePlatformUserAccountData(platform as PLATFORM, userId, {
          username,
        })
      }
    },
  },
]
